/* eslint-disable spaced-comment */
import React from 'react';
import PropTypes from 'prop-types';
import { AvFeedback, AvField, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { Col, Label } from 'reactstrap';

const CreateResidentForm = ({ user, devices }) => {
  const resident = user || {};
  return (
    <React.Fragment>
      <AvInput type="hidden" name="id" defaultValue={resident.id} />
      <AvGroup row>
        <Label sm={2} for="name" className="text-right">Name</Label>
        <Col sm={10}>
          <AvInput type="text" className="form-control" name="name" placeholder="Name" defaultValue={resident.name} required />
          <AvFeedback color="danger">Please enter a name</AvFeedback>
        </Col>
      </AvGroup>

      <AvGroup row>
        <Label sm={2} for="deviceId" className="text-right">Device Id</Label>
        <Col sm={10}>
          <AvField
            type="select"
            name="deviceId"
            value={user && user.device ? user.device.deviceId : 'NO_DEVICE'}
          >
            <option value="NO_DEVICE">No device</option>
            {
              devices
                .sort((a, b) => a.deviceId.slice(-4).localeCompare(b.deviceId.slice(-4)))
                .map(device => (
                  <option
                    key={device.id}
                    value={device.deviceId}
                  >
                    ...{device.deviceId.slice(-4)} {device.resident && ` - ${device.resident.name}`}
                  </option>
                ))
            }
          </AvField>
          <AvFeedback color="danger">Please select device</AvFeedback>
        </Col>
      </AvGroup>

      <AvGroup row>
        <Label sm={2} for="roomNumber" className="text-right">Room #</Label>
        <Col sm={10}>
          <AvInput type="text" className="form-control" name="roomNumber" placeholder="e.g. Room 127" defaultValue={resident.roomNumber} />
          <AvFeedback color="danger">Please enter a room number</AvFeedback>
        </Col>
      </AvGroup>

      {/*<AvGroup row>*/}
      {/*<Label sm={2} for="phone" className="text-right">Phone (SMS)</Label>*/}
      {/*<Col sm={10}>*/}
      {/*<AvInput type="tel" className="form-control" name="phone" placeholder="801-555-1234" required />*/}
      {/*<AvFeedback color="danger">Please enter a valid (US) phone number</AvFeedback>*/}
      {/*</Col>*/}
      {/*</AvGroup>*/}
    </React.Fragment>
  );
};

CreateResidentForm.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    deviceId: PropTypes.string.isRequired,
    resident: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  })),
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    deviceId: PropTypes.string,
    roomNumber: PropTypes.string,
  }),
};

CreateResidentForm.defaultProps = {
  devices: [],
  user: null,
};

export default CreateResidentForm;



// WEBPACK FOOTER //
// ./src/components/CreateResidentForm.js